import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { goToCareersSite } from "../utils/careersSiteUrl";
import { useLanguage } from "../i18n/LanguageContext";

export default function AudiencePaths() {
  const { t } = useLanguage();

  const handleViewServices = () => {
    const servicesSection = document.getElementById("our__services");
    if (servicesSection) {
      const topOffset = servicesSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <section className="amgPaths" id="audience__paths" aria-labelledby="amg-paths-heading">
      <div className="amgPathsInner">
        <div className="amgPathsIntro">
          <p className="amgPathsEyebrow">{t("paths.eyebrow")}</p>
          <h2 className="amgPathsHead" id="amg-paths-heading">
            {t("paths.heading")}
          </h2>
        </div>

        <div className="amgHeroCards">
          <article className="amgHeroCard amgHeroCard--company" data-aos="fade-up">
            <span className="amgHeroBadge amgHeroBadge--company">
              {t("paths.employers")}
            </span>
            <h2 className="amgHeroCardHead">{t("paths.employersHead")}</h2>
            <p className="amgHeroCardPara">{t("paths.employersBody")}</p>
            <button
              type="button"
              onClick={handleViewServices}
              className="amgHeroBtn amgHeroBtn--gold"
            >
              {t("paths.viewServices")}
            </button>
          </article>

          <article className="amgHeroCard amgHeroCard--seeker" data-aos="fade-up">
            <span className="amgHeroBadge amgHeroBadge--seeker">
              {t("paths.candidates")}
            </span>
            <h2 className="amgHeroCardHead">{t("paths.candidatesHead")}</h2>
            <p className="amgHeroCardPara">{t("paths.candidatesBody")}</p>
            <button
              type="button"
              onClick={goToCareersSite}
              className="amgHeroBtn amgHeroBtn--gold"
            >
              {t("paths.submitCv")}
            </button>
          </article>
        </div>
      </div>
    </section>
  );
}
